import React from 'react';
import PropTypes from 'prop-types';
import PaymentFormRow from '../../PaymentFormRow/PaymentFormRow';
import classes from './CfRenderRestFields.module.scss';

const CfRenderRestFields = (props) => {
    const {
        formBlockData,
        formik,
        studentDetails,
        isStudentVerified,
        studentDetailsApiCount,
        isOtpVerified,
        ppJsonData,
        // New props for primary identifier
        isPrimaryIdentifierFlow,
        isPrimaryOtpVerified,
    } = props;

    const isActiveStudent = studentDetails?.stud_bd?.status === 'ACTIVE' || false;
    const mobileInput = formBlockData?.fields?.flat()?.find((field) => field?.input_id === 'customer_mobile');
    const emailInput = formBlockData?.fields?.flat()?.find((field) => field?.input_id === 'customer_email');

    const blockUnverifiedStudent = formBlockData?.form_config?.block_unverified_student ?? false;
    const enableMobileOtpVerification = formBlockData?.form_config?.enable_otp_verification ?? false;
    const enableEmailOtpVerification = formBlockData?.form_config?.enable_email_otp_verification ?? false;

    const renderRestFields = () => {
        // Handle primary identifier flow
        if (isPrimaryIdentifierFlow) {
            // Get primary identifier type
            const primaryIdentifier = formBlockData?.form_config?.primary_identifier;
            const isPrimaryMobile = primaryIdentifier === 'customer_mobile';
            const isPrimaryEmail = primaryIdentifier === 'customer_email';
            
            // Check if OTP is required for primary identifier
            const primaryOtpRequired = (isPrimaryMobile && enableMobileOtpVerification) || 
                                       (isPrimaryEmail && enableEmailOtpVerification);
            
            if (primaryOtpRequired) {
                // If primary OTP is required, only check primary OTP completion
                if (isPrimaryOtpVerified) {
                    return formBlockData?.fields?.map((formRowList, index) => (
                        <PaymentFormRow
                            key={`form-row-${index}`}
                            data={ppJsonData}
                            formRowListData={formRowList}
                            formik={formik}
                        />
                    ));
                } else {
                    return null;
                }
            } else {
                // If primary OTP is not required, check for customer OTP requirement
                let customerOtpRequired = false;
                if (isPrimaryMobile && enableEmailOtpVerification) {
                    customerOtpRequired = true;
                } else if (isPrimaryEmail && enableMobileOtpVerification) {
                    customerOtpRequired = true;
                }
                
                if (customerOtpRequired) {
                    // Customer OTP is required, check if verified
                    if (isOtpVerified) {
                        return formBlockData?.fields?.map((formRowList, index) => (
                            <PaymentFormRow
                                key={`form-row-${index}`}
                                data={ppJsonData}
                                formRowListData={formRowList}
                                formik={formik}
                            />
                        ));
                    } else {
                        return null;
                    }
                } else {
                    // No OTP required at all, render directly
                    return formBlockData?.fields?.map((formRowList, index) => (
                        <PaymentFormRow
                            key={`form-row-${index}`}
                            data={ppJsonData}
                            formRowListData={formRowList}
                            formik={formik}
                        />
                    ));
                }
            }
        }

        // Original flow (unchanged)
        if ((mobileInput && enableMobileOtpVerification) || (emailInput && enableEmailOtpVerification)) {
            if (isOtpVerified) {
                return formBlockData?.fields?.map((formRowList, index) => (
                    <PaymentFormRow
                        key={`form-row-${index}`}
                        data={ppJsonData}
                        formRowListData={formRowList}
                        formik={formik}
                    />
                ));
            } else {
                return null;
            }
        } else {
            return formBlockData?.fields?.map((formRowList, index) => (
                <PaymentFormRow
                    key={`form-row-${index}`}
                    data={ppJsonData}
                    formRowListData={formRowList}
                    formik={formik}
                />
            ));
        }
    };

    if (!blockUnverifiedStudent) {
        if (studentDetails) {
            return isActiveStudent ? renderRestFields() : null;
        } else {
            return studentDetailsApiCount > 0 ? renderRestFields() : null;
        }
    }

    return <div>{isStudentVerified && studentDetails && <>{isActiveStudent && renderRestFields()}</>}</div>;
};

CfRenderRestFields.propTypes = {
    formBlockData: PropTypes.object,
    formik: PropTypes.object,
    studentDetails: PropTypes.object,
    isStudentVerified: PropTypes.bool,
    studentDetailsApiCount: PropTypes.number,
    isOtpVerified: PropTypes.bool,
    ppJsonData: PropTypes.object,
    isPrimaryIdentifierFlow: PropTypes.bool,
    isPrimaryOtpVerified: PropTypes.bool,
};

export default CfRenderRestFields;
